
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[lang]/account/credits",
      function () {
        return require("private-next-pages/[region]/[lang]/account/credits.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[lang]/account/credits"])
      });
    }
  